<template>
  <div>
    <v-data-table
      fixed-header
      :height="tableHeight"
      :headers="headers"
      :items="modelList"
      :options.sync="options"
      :loading="loading"
      :server-items-length="paginatorTotal"
      :footer-props="footerProps"
      class="elevation-1"
    />
  </div>
</template>

<script>
import ListMixin from '@/mixins/list-mixin.vue'
import DictionaryMixin from '@/mixins/dictionaryMixin'
import { formatDate } from '@/utils/date-util'

export default {
  name: 'WBDRegionListPage',
  mixins: [ListMixin, DictionaryMixin],
  data: () => ({
    loading: true,
    paginatorTotal: null,
    modelList: [],
    selectedRegion: null,
    editModalShowMode: false,
    options: {},
    smsListFilterSet: {
      searchQuery: null,
    },
    headers: [
      {
        text: 'Сообщение',
        align: 'left',
        sortable: false,
        value: 'message',
      },
      {
        text: 'Дата отправки',
        align: 'left',
        sortable: false,
        value: 'dateString',
      },
      {
        text: 'Статус',
        align: 'left',
        sortable: false,
        value: 'status',
      },
      {
        text: 'Ошибка',
        align: 'left',
        sortable: false,
        value: 'error',
      },
      { text: '', value: 'options' },
    ],

  }),
  computed: {
  },
  watch: {
    options: {
      handler () {
        this.loadRegionList(this.options.page, this.options.itemsPerPage)
      },
      deep: true,
    },
  },
  async created () {
    this.options = {
      page: 1,
      itemsPerPage: this.footerProps.itemsPerPageOptions[1],
    }
  },
  methods: {
    onCreatedModalShowMode () {
    },
    onOpenEditModalShowMode (city) {
    },
    onCloseEditModalShowMode (save) {
    },
    async save () {
    },
    async loadRegionList (page, size) {
      try {
        const params = { 'page[number]': page, 'page[size]': size }
        const { sortBy, sortDesc } = this.options

        if (sortBy && sortBy.length) {
          for (const [index, item] of sortBy.entries()) {
            params[`ordering[${item}]`] = sortDesc[index] ? 'DESC' : 'ASC'
          }
        }

        const { searchQuery } = this.smsListFilterSet

        if (searchQuery && searchQuery.trim().length > 0) {
          params.searchQuery = searchQuery
        }

        const response = await this.$store.dispatch(
          'organization/getSms',
          { params }
        )

        this.modelList = response.data.map((item) => ({
          ...item,
          dateString: formatDate(item.createdAt),
          status: item.externalId ? 'Отправлен' : 'Создан',
        }))

        if (response.headers['x-total-count']) {
          this.paginatorTotal = parseInt(response.headers['x-total-count'], 10)
        } else {
          this.paginatorTotal = this.footerProps.itemsPerPageOptions[1]
        }


        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    async resetFilterSet () {
      const hasFilter = this.getActiveFilterNumber
      this.smsListFilterSet = {
        searchQuery: null,
      }

      this.eventsBus.$emit(this.eventNames.PAGE_REGION_LIST_FILTER_RESET)

      if (hasFilter > 0) {
        await this.loadRegionList(1, this.options.itemsPerPage)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.office-item {
  cursor: pointer;
}
</style>
